export const LocationArrowDisabledIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      className="location-arrow"
      fill="#0E0E0E"
      d="M12.758 3.332 1.7 8.14c-1.907.829-1.44 3.654.631 3.827l4.083.34.34 4.084c.173 2.071 3 2.537 3.828.631L15.39 5.963c.724-1.665-.966-3.355-2.632-2.631Z"
    />
    <path
      className="location-arrow"
      fill="#0E0E0E"
      d="M18 17.77a1 1 0 0 1-1.414 1.415l-16-16A1 1 0 1 1 2 1.771l16 16Z"
    />
    <path
      className="location-arrow-strikethrough"
      fill="#fff"
      d="m2.293 2.063 16 16 2.414-.878-1.414-.664-16-15.999-1 1.54Z"
    />
  </svg>
);
